// Single source of truth for amenity / land-feature human labels.
//
// Add new amenity slugs here and they'll automatically render correctly on
// PropertyCard, PropertyDetailPage, the admin form, and the public Properties
// filter panel.

export const AMENITY_LABELS = {
  // Villa / building amenities
  private_pool: 'Private Pool',
  shared_pool: 'Shared Pool',
  garden: 'Garden',
  ocean_view: 'Ocean View',
  staff_included: 'Staff Included',
  beach_access: 'Walking Distance to Beach',
  parking: 'Parking',
  wifi: 'WiFi',
  air_conditioning: 'Air Conditioning',
  spa: 'Spa',
  gym: 'Gym',
  newly_built: 'Newly Built',
  // Land-specific features
  rice_field_view: 'Rice Field View',
  mountain_view: 'Mountain View',
  road_frontage: 'Road Frontage',
  corner_plot: 'Corner Plot',
  utilities_available: 'Utilities Available',
  river_stream: 'River / Stream',
  cleared_ready_to_build: 'Ready to Build',
};

/**
 * Pretty-print an amenity slug.
 * Falls back to a title-cased version of the slug for any value not in the map
 * so we never render raw `snake_case` again.
 */
export const prettifyAmenity = (slug) => {
  if (!slug) return '';
  if (AMENITY_LABELS[slug]) return AMENITY_LABELS[slug];
  return slug
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
};
